
import color from "../../../../../constants/color";

const style = {
  card: {
    mt: 2,
    backgroundColor: "#fff",
    padding: "10%",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center  ",
    justifyContent: "space-Between"
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },
  dateCard: {
    mt: 2,
    backgroundColor: "#fff",
    padding: "4%",
    borderRadius: "20px",
    display: { xs: "block", md: "flex" },
    alignItems: "center  ",
    justifyContent: "space-Between"
    // gridColumn:{ xs: "span 12", md: "span 3" }
  },

  inputSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },

  inputBox: {
    width: { xs: "100%", md: "49%", lg: "31%" }
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1
  },

  dateInput: {
    width: "100%",
    my: 1,


    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  tableHead: {
    color: "#878787",
    fontWeight: "400",
  },

  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },


  checkinBtn: {

    "& svg": {
      mr: 1,
    },
    borderRadius: 50,
    backgroundColor: "#28AA4A",
    color: "#fff",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",

  },
  checkinBtns: {

    "& svg": {
      mr: 1,
    },
    borderBottomRightRadius: 50,
    borderTopRightRadius: 50,

    backgroundColor: "#28AA4A",
    color: "#fff",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",

  },
  mainGrid: {
    px: "15px",
    pt: "20px",
    display: { xs: "block", md: "flex" },
    justifyContent: "space-between",
    alignItems: "center",
  },
  textGrid: {
    display: "flex",
    justifyContent: { xs: "start", md: "end" },
    alignItems: { xs: "start", md: "end" },
    mt: { xs: 2, md: 0 },
  },
  whiteSection: {
    backgroundColor: color.card,
    m: 2,
    borderRadius: "20px",
  },
  csvBtns: {

    "& svg": {
      mr: 1,
    },

    borderBottomLeftRadius: 50,
    borderTopLeftRadius: 50,
    px: 1,
    backgroundColor: color.card,
    color: color.text,
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",

  },
  paidButton: {

    "& svg": {
      mr: 1,
    },
    mr:2,
    borderRadius:50,
    px: 3,
    color: "#fff",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "500",
    boxShadow: "none",
    backgroundColor:"#28AA4A"

  },

  inputGrids: {
    width: "100%"
  },

  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: "10px"
  },
  hoursInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",

    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",

    },

  },




}
export default style;